import { useContext, useEffect } from "react";
import MapContext from "../Map/MapContext";

import { connect } from "react-redux";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import { Vector as SoVector } from "ol/source";
import { Vector } from "ol/layer";
import { GeoJSON } from "ol/format";



const CouchesLayer = ({ zIndex = 0, listecouches, fonddecarte }) => {
	const { map } = useContext(MapContext);

	
	useEffect(() => {
		//console.log(listecouches);
		if (!map) return;
		var listelayers = [];

		listecouches.forEach(element => {
			var fichier = "";
			var couleur = "";
			var epaisseurtrait = 1;
			var couleurremplissage = "#FFFFFF00";

			switch (element) {
				case "bouchesdurhone":
					fichier = `${process.env.PUBLIC_URL}/couches/bdr.geojson`;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba(11,5,4,0.8)";
					epaisseurtrait = 1.5;
					break;
				case "ct":
					fichier = `${process.env.PUBLIC_URL}/couches/BDR_EPCI.geojson`;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba( 72, 72, 72, 0.67 )";
					epaisseurtrait = 1.5;
					break;
				case "metropole":
					fichier = `${process.env.PUBLIC_URL}/couches/Metropole_limite_sans_littoral.geojson`;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba( 18, 68, 68, 0.87 )";
					epaisseurtrait = 1.5;
					break;
				case "communesavecarrondissement":
					fichier = `${process.env.PUBLIC_URL}/couches/BDR_limite_communes_avec_arrdt.geojson`;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba(142,142,142,0.57)";
					epaisseurtrait = 1;
					break;
				case "communessansarrondissement":
					fichier = `${process.env.PUBLIC_URL}/couches/BDR_limite_communes_sans_arrdt.geojson`;
					epaisseurtrait = 1;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba(142,142,142,0.57)";
					break;
				case "polesurbain":
					fichier = `${process.env.PUBLIC_URL}/couches/PolesUrbainsReperesLocaux.geojson`;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba( 128, 128, 128, 0.67 )";
					break;
				case "tachesurbaine":
					fichier = `${process.env.PUBLIC_URL}/couches/tache_urbaine.geojson`;
					couleur = fonddecarte === 'Orthophoto' ? "rgba(240,240,240,0.8)" : "rgba( 128, 128, 128, 0.67 )";
					couleurremplissage = "rgba(176,176,176,0.37)";
					break;
				default:
					break;

			}

			fetch(fichier)
				.then(r => r.json())
				.then(couche => {

					var style = new Style({
						stroke: new Stroke({
							color: couleur, //"rgba(0,0,0,0.5)",
							width: epaisseurtrait
						}),
						fill: new Fill({
							color: couleurremplissage
						}),
						opacity: 0.5,
						zIndex: 100
					});
					var vectorSource = new SoVector({
						features: (new GeoJSON()).readFeatures(couche)
					});
					var vectorLayer = new Vector({
						source: vectorSource,
						style: style,
						nom:element,
						//nomcouche: idcouche
					});
					map.addLayer(vectorLayer);
					listelayers.push(vectorLayer)
				})

		});
		return () => {
			if (map) {
				listelayers.forEach(layer => {
					map.removeLayer(layer);
				})
			}
		};


		// eslint-disable-next-line
	}, [map, listecouches]);

	return null;
};


function mapStateToProps(state) {

	return {
		listecouches: state.listecouches,
		fonddecarte: state.fonddecarte
	}
}

export default connect(mapStateToProps)(CouchesLayer);